export default "__VITE_ASSET__D7N2E0Nh__"